import type { MRT_ColumnDef } from "mantine-react-table";
import type { MetadataDocument } from "../types";
import { createDateColumn, createStringColumn } from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "field_service_reports";

export const fsrColumns: MRT_ColumnDef<MetadataDocument>[] = [
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.report_name",
        header: "Report Name",
        accessor: (row) => row.fields?.report_name ?? "N/A",
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Customer Name",
        header: "Customer Name",
        accessor: (row) => row.fields?.["Customer Name"] ?? "N/A",
        overrides: {
            filterVariant: "autocomplete",
            enableFilterMatchHighlighting: true,
            enableClickToCopy: false,
        },
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Machine No",
        header: "Machine No",
        accessor: (row) => row.fields?.["Machine No"] ?? "N/A",
    }),
    createDateColumn<MetadataDocument>({
        namespace,
        field: "metadata.Date",
        header: "Date",
        overrides: {
            Header: ({ column }) => <em>{column.columnDef.header}</em>,
        },
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Type of Activity",
        header: "Type of Activity",
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Codeword",
        header: "Codeword",
        overrides: { size: 300 },
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Product Type",
        header: "Product Type",
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Location",
        header: "Location",
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Author(s)",
        header: "Author(s)",
        overrides: { size: 150 },
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Project",
        header: "Project",
    }),
    createStringColumn<MetadataDocument>({
        namespace,
        field: "metadata.Order No Internal",
        header: "Order No Internal",
    }),
    createLinkColumn<MetadataDocument>({
        namespace,
        field: "metadata.source",
        header: "Source",
        accessor: (row) => row.fields?.source ?? "N/A",
    }),
];
